import { GET_HCP_VERIFICATIONS_QUERY_KEY } from '../../contracts';
import { getAdsDataConfig } from '../config';

export const invalidateHcpVerificationStatus = () =>
  getAdsDataConfig().queryClient.invalidateQueries({
    queryKey: [GET_HCP_VERIFICATIONS_QUERY_KEY],
  });
